import dayjs from "dayjs"
import { ElMessageBox } from 'element-plus'

const $str = window.$str;



export { cloneDeep } from "@/utils"
export { checkPermi } from '@/utils/permission.js'



/**
 * elink数据的符号
 * @type {symbol}
 */
export const cur_elk = Symbol.for('currentELinkData')

/**
 * 一天的分钟数
 * @type {number}
 */
export const minutesOfDay = 1440


export const STRATEGY_MODE_OPTIONS = [
  { value: 0, label: '削峰填谷模式', thresholdType: 'reflux' },
  { value: 1, label: '光伏自发自用', thresholdType: 'pv' },
  { value: 2, label: '只充光伏余电', thresholdType: 'pv' },
]

/**
 * 根据模式值获取门限值类型：'pv'（光伏防逆流门限值）/ 'reflux'（防逆流值）
 * @param {string} mode
 * @returns {'pv'|'reflux'|''}
 */
export function getThresholdTypeByMode(mode) {
  const item = STRATEGY_MODE_OPTIONS.find(it => it.value === mode)
  return item ? item.thresholdType : ''
}

/**
 * 获取门限值输入框的占位提示
 * @param {string} mode
 * @returns {string}
 */
export function getThresholdPlaceholder(mode) {
  const type = getThresholdTypeByMode(mode)
  if (type === 'pv')     { return '光伏防逆流门限值' }
  if (type === 'reflux') { return '防逆流值'         }
  return '关口门限'
}




export function translateThirdCtrl(c) {
  if (c === '0' || c === false) {
    return $str.getKey('策略控制/否')
  } else if (c === '1' || c === true) {
    return $str.getKey('策略控制/是')
  } else {
    return '--'
  }
}


export function translateResultCode(code) {
  const Codes = {
    200: $str.getKey('策略控制/策略满足条件'),
    201: $str.getKey('策略控制/策略未覆盖24小时'),
    202: $str.getKey('策略控制/控制模式为本地控制'),
    203: $str.getKey('策略控制/控制源为非eMind控制'),
  }
  return Codes[code] || '--'
}

export function formmatTime(t) {
  return dayjs(t).format('YYYY-MM-DD HH:mm:ss')
}



/**
 * 计算策略类型:工作日|休息日
 * @param {*} plans 特殊计划 
 * @param {*} date 日期
 * @param {*} week_plan 充放电模式
 * @returns {'work'|'rest'}
 */
export function calculationStrategyType(plans, date, week_plan) {
  let day = date.getDay()
  let isRest = false

  // 单休
  if (week_plan === '1') {
    isRest = day === 0
  }
  // 双休
  else if (week_plan === '2') {
    isRest = day === 6 || day === 0
  }
  // 无休
  else if (!week_plan || week_plan === '0') {
    isRest = false
  }
  let cur = isRest ? 'rest' : "work"

  // 特殊计划优先
  plans.forEach((plan) => {
    let day = dayjs(plan.strategy_date).format("YYYY-MM-DD")
    let dataDay = dayjs(date).format("YYYY-MM-DD")
    if (day === dataDay) {
      cur = plan.strategy_type;
    }
  });

  return cur;
}




/**
 * 生成预约策略
 * @param index 序号
 * @returns {{strategys_rest: *[], custom_strategy_name: string, week_plan: string, strategys_work: *[], demand: number, execution_time: string, third_ctl_en: null}}
 * @constructor
 */
export function Appointment(index=1) {
  return {
    disabled: false,
    custom_strategy_name: $str.getKey('策略控制/预约策略') + index,
    execution_time: '',
    demand: 0,
    week_plan: '0',
    third_ctl_en: null,
    strategys_rest: [],
    strategys_work: [],
  }
}


/**
 * 布尔值转化为 0 或 1
 * @param bool
 * @returns {string}
 */
export function toBinStr(bool) {
  if (bool) {
    return '1'
  } else {
    return '0'
  }
}


/**
 * 转化策略格式为驼峰命名
 * @param item
 * @returns {{startTime: (string|*), upperLimit: (string|*|number), endTime: (string|*), lowerLimit: (string|*|number), power: number}}
 */
export function strategyData2CamelCase(item) {
  return {
    startTime: item.start_time ?? item.startTime,
    endTime: item.end_time ?? item.endTime,
    lowerLimit: item.lower_limit ?? item.lowerLimit ?? 0,
    upperLimit: item.upper_limit ?? item.upperLimit ?? 100,
    power: item.power * 1,
    running_mode: item.running_mode ?? item.mode ?? '',
    threshold_val: item.threshold_val ?? item.threshold ?? 10,
  }
}


/**
 * 转化策略格式为下划线命名
 * @param item
 * @returns {{start_time: (string|*), lower_limit: (string|*|number), end_time: (string|*), upper_limit: (string|*|number), power: number}}
 */
export function strategyData2UnderscoreCase(item) {
  return {
    start_time: item.startTime ?? item.start_time,
    end_time: item.endTime ?? item.end_time,
    lower_limit: item.lowerLimit ?? item.lower_limit ?? 0,
    upper_limit: item.upperLimit ?? item.upper_limit ?? 100,
    power: item.power * 1,
    running_mode: item.running_mode ?? item.mode ?? '',
    threshold_val: item.threshold_val ?? item.threshold ?? 10,
  }
}

/**
 * 转化策略数组格式
 * @param array
 * @param toCamel
 * @returns {*|*[]}
 */
export function transformJSON(array, toCamel = true) {
  if (!Array.isArray(array)) {
    return []
  }
  return array.map((item) => toCamel ? strategyData2CamelCase(item) : strategyData2UnderscoreCase(item))
}

/**
 * 根据策略数据生成echarts配置对象
 * @param chartDataSource
 * @returns {*}
 */
export function createOption(chartDataSource=[], powerLimit) {

  chartDataSource = transformJSON(chartDataSource)
  let formayedNowDay = dayjs().format('YYYY-MM-DD')

  let seriesData = chartDataSource.map((item) => {
    let startTime = dayjs(formayedNowDay + ' ' + item.startTime).format('YYYY-MM-DD HH:mm:ss')
    let endTime = dayjs(formayedNowDay + ' ' + item.endTime).format('YYYY-MM-DD HH:mm:ss')
    let power = item.power;

    let color = "#BCC6DD";
    if (power > 0) {
      color = "#24A517";
    } else if (power < 0) {
      color = "#596EFF";
    }

    return {
      value: [startTime, endTime, power, item.upperLimit, item.lowerLimit],
      itemStyle: {
        normal: {
          color: color,
        },
      },
    };
  });
  let min = dayjs().format("YYYY-MM-DD ") + "00:00:00";
  let max = dayjs().add(1, "days").format("YYYY-MM-DD ") + "00:00:00";

  return getChartOption(seriesData, min, max, powerLimit)

}


/**
 * 获取策略名称
 * @param sType
 * @returns {*}
 */
export function strategyNameFromType(sType) {
  const nameMap = {
    work: $str.getKey('策略控制/工作日策略'),
    rest: $str.getKey('策略控制/休息日策略'),
  }
  return nameMap[sType]
}


/**
 * 辅助函数，用于将时间字符串转换为分钟表示 如 12:00  ->  720
 * @param time
 * @returns {number}
 */
export function timeToMinutes(time) {
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}


/**
 * 检测一条策略的合法性
 * @param strategy
 * @param showError
 * @returns {boolean}
 */
export function checkStrategyValidate(strategy, powerLimit, showError = false) {
  let camelStrategy = strategyData2CamelCase(strategy)

  const keyMap = {
    startTime: $str.getKey('策略控制/开始时间'),
    endTime: $str.getKey('策略控制/结束时间'),
    power: $str.getKey('策略控制/功率'),
    upperLimit: $str.getKey('策略控制/充电上限'),
    lowerLimit: $str.getKey('策略控制/放电下限'),
  };

  const patterns = {
    startTime: /^\d{2}:\d{2}$/,
    endTime: /^\d{2}:\d{2}$/,
    power(key, value) {
      return value >= (powerLimit * -1) && value <= powerLimit
    },
    upperLimit(key, value) {
      return value >= 0 && value <= 100
    },//: /^(?:0|[1-9][0-9]?|100)$/,
    lowerLimit(key, value) {
      return value >= 0 && value <= 100
    },//: /^(?:0|[1-9][0-9]?|100)$/,
  }

  const validate = (key, value) => {
    if (value == null) {
      return false
    }
    let regexp = patterns[key]
    if (regexp instanceof RegExp) {
      if (!regexp.test(value)) {
        return false
      }
    } else if (regexp instanceof Function) {
      return regexp(key, value)
    }
    return true
  }

  let valid = true
  for (const [key, value] of Object.entries(camelStrategy)) {
    let name = keyMap[key]
    if (!validate(key, value)) {
      if (showError) {
        window.dispatchNotify({
          type: 'info',
          message: $str.getKey('策略控制/请输入正确的') + name
        });
      }
      valid = false
      break
    }
  }

  return valid
}


/**
 * 检查策略列表的合法性
 * @param strategys
 * @param powerLimit
 * @returns {boolean}
 */
export function checkStrategyListValidate(strategys, powerLimit) {
  for (const strategy of strategys) {
    let valid = checkStrategyValidate(strategy, powerLimit, true)
    if (!valid) {
      return false
    }
  }
  return true
}


/**
 * 检测策略时间槽
 * @param timeSlots
 * @returns {boolean}
 */
export function isTimeSlotValid(timeSlots) {
  // 辅助函数，用于检查两个时间段是否重合  
  function isOverlap(slot1, slot2) {
    return !(timeToMinutes(slot2.start_time) >= timeToMinutes(slot1.end_time) || timeToMinutes(slot1.start_time) >= timeToMinutes(slot2.end_time))
  }

  // 排序时间槽，确保它们按开始时间升序排列  
  timeSlots.sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time))

  // 检查时间槽是否重合，并且结束时间不是'00:00'或'24:00'  
  for (let i = 0; i < timeSlots.length - 1; i++) {
    const currentSlot = timeSlots[i]
    const nextSlot = timeSlots[i + 1]

    if (isOverlap(currentSlot, nextSlot)) {
      return false
    }

    if (currentSlot.end_time === '00:00' || currentSlot.end_time === '24:00') {
      return false
    }
  }

  // 检查最后一个时间槽的结束时间是否接近或等于'24:00'
  if (timeSlots.length > 0 && (timeSlots[timeSlots.length - 1].end_time !== '23:59' && timeToMinutes(timeSlots[timeSlots.length - 1].end_time) !== 1439)) {
    return false
  }

  return true
}



/**
 * 比较两个策略列表是否相同
 * @param {*} sa 
 * @param {*} sb 
 * @returns 
 */
export function compareStrategy(sa, sb) {
  if (!Array.isArray(sa) || !Array.isArray(sb)) {
    return false
  }

  if (sa.length !== sb.length) {
    return false
  }


  // 都转化为字符串，并且忽略 created_time strategy_id 等的比较
  const convert = (array) => {
    var arr = array.map((item) => strategyData2UnderscoreCase(item))

    arr.forEach(elem => {
      elem.lower_limit = parseFloat(elem.lower_limit)
      elem.upper_limit = parseFloat(elem.upper_limit)
      elem.power = parseFloat(elem.power)
    })

    arr.sort((a, b) => {
      return timeToMinutes(a.start_time) - timeToMinutes(b.start_time)
    })

    return arr
  };

  const isSameObj = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b)
  }

  sa = convert(sa)
  sb = convert(sb)

  return isSameObj(sa, sb)
}


export function cusConfirm(message) {
  return new Promise(resolve => {
    ElMessageBox.confirm(message, {
      title: $str.getKey('全局/系统提示'),
      type: "warning",
    }).then(() => resolve(true)).catch(() => resolve(false));
  });
}


/**
 * 从时间字符串中，获取分钟总数
 * @param {*} time '15:40'
 * @returns 940
 */
export function getMinutesCountByTime(time) {
  const arr = time.split(':');
  const h = +arr[0] * 60;
  const m = +arr[1] * 1;
  return h + m;
}





export function getChartOption(sData = [], min, max, powerLimit) {
  if (min === undefined) { min = dayjs().format('YYYY-MM-DD 00:00:00'); }
  if (max === undefined) { max = dayjs().add(1, 'day').format('YYYY-MM-DD 00:00:01'); }
  powerLimit = undefined // TODO: 若需要在图表中指定y轴上下限，请删除此行代码

  const getTitle = () => {
    if (showTitle) {
      return {
        text: `运行策略 (${date})  ${strategyName}`,
        x: "center"
      }
    }
  }
  const option = {
    tooltip: {
      className: 'chart-tooltip',
      backgroundColor: 'transparent',
      borderColor: 'var(--color-black-6)',
      formatter(value) {
        const [st, et, power, upper, lower] = value.data.value || []

        let startTime = dayjs(st).format('HH:mm')
        let endTime = dayjs(et).format('HH:mm')

        const html = /*html*/`
        <div class="chart-tooltip-wrapper">
          <div class="chart-tooltip__series"><span class="chart-tooltip__series-name">${$str.getKey('策略控制/开始时间')}: </span> <span class="chart-tooltip__value">${startTime}</span></div>
          <div class="chart-tooltip__series"><span class="chart-tooltip__series-name">${$str.getKey('策略控制/结束时间')}: </span><span class="chart-tooltip__value">${endTime}</span></div>
          <div class="chart-tooltip__series"><span class="chart-tooltip__series-name">${$str.getKey('策略控制/功率')}(kW): </span><span class="chart-tooltip__value">${power}</span></div>
          <div style="margin: 10px 0px; border-top: 1px solid ${value.color}"></div>
          <div class="chart-tooltip__series" style="display: ${upper != null ? 'flex' : 'none'}">
            <span class="chart-tooltip__series-name">${$str.getKey('策略控制/充电上限')}(%): </span>
            <span class="chart-tooltip__value">${upper}</span>
          </div>
          <div class="chart-tooltip__series" style="display: ${lower != null ? 'flex' : 'none'}">
            <span class="chart-tooltip__series-name">${$str.getKey('策略控制/放电下限')}(%): </span>
            <span class="chart-tooltip__value">${lower}</span>
          </div>
        </div> `
        return html
      }
    },
    series: {
      type: "custom",
      renderItem(params, api) {
        var yValue = api.value(2)
        var start = api.coord([api.value(0), yValue])
        var size = api.size([api.value(1) - api.value(0), yValue])
        var style = api.style()
        return {
          type: 'rect',
          shape: {
            x: start[0],
            y: start[1] <= 0 ? start[1] + 4 : start[1] - 4,
            width: size[0],
            height: 8
          },
          style: style
        };
      },
      label: {
        show: true,
        position: "top"
      },
      dimensions: [
        "开始时间 ",
        "结束时间 ",
        "功率（kW） "
      ],
      encode: {
        x: [
          0,
          1
        ],
        y: 2,
        tooltip: [
          0,
          1,
          2
        ],
        itemName: 4
      },
      data: sData
    },
    xAxis: {
      scale: true,
      type: "time",
      splitNumber: 12,
      splitLine: {
        show: false,
        lineStyle: {
          color: ['#2e3648']
        }
      },
      axisLine: {
        lineStyle: {
          color: "#7C868D",
        }
      },
      min: min,
      max: max,
      axisLabel: {
        formatter: function (params, index) {
          const time = dayjs(Number(params))
          return time.hour() % 2 === 0 ? time.format("HH:mm") : '';
        }
      }
    },
    yAxis: {
      min: Number.isNaN(powerLimit * -1) ? undefined : (powerLimit * -1).toFixed(2),
      max: Number.isNaN(powerLimit * 1) ? undefined : (powerLimit * 1).toFixed(2),
      show: true,
      axisLine: {
        lineStyle: {
          color: "#7C868D"
        }
      },
      splitLine: {
        lineStyle: {
          width:2,
          color: ['#9199B033']
        }
      },
      splitNumber: 10
    },
    grid: {
      top: 30,
      left: 50,
      bottom: 50,
      right: 10,
    }
  }


  return option;

}


